import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import classes from "./createJobProfile.module.css";
import MultiSelect from "../../commonComponents/MultiSelect";
import { connect } from "react-redux";
// import Loader from 'react-loader-advanced';
// import Spinner from 'react-bootstrap/Spinner'
import * as actionTypes from "../../../Action/Index";
// import SweetAlert from '../../commonComponents/SweetAlert'
import Select from "react-select";

class CreateJobProfile extends Component {
  state = {
    options: [],
    file: "",
    min: 0,
    max: 30,
    skillsRequired: false,
    preferredSkillsRequired: false,
    skills_mustHave: [],
    skills_preferred: [],
    skills_mustHaveOthers: [],
    skills_preferredOthers: [],
    titleErrorMsg: "",
    skillsErrorMsg: "",
    commonArray: "",
    maxErrorMsg: "",

    nameErrorMsg: "",
    yearsErrorMsg: "",
    skillsErrorMsg: "",
    mobileErrorMsg: "",
    emailErrorMsg: "",

    fileRequired: false,
    skillsRequired: false,
    invalidFormat: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (e.target.jobTitle.value === "") {
      this.setState({
        titleErrorMsg: "Enter a Job title",
        skillsErrorMsg: "",
        clientErrorMsg: "",
      });
    }

    // else if(e.target.clientname.value === ""){
    //     this.setState({
    //         titleErrorMsg: "",
    //         clientErrorMsg:"Enter a Client name",
    //         skillsErrorMsg: "",

    //     })
    // }
    else if (e.target.max.value === "") {
      this.setState({
        maxErrorMsg: "Enter Experience",
        titleErrorMsg: "",
        skillsErrorMsg: "",
        clientErrorMsg: "",
      });
    } else if (!/^[A-Za-z+/ *_$@# 0-9.-]+$/i.test(e.target.jobTitle.value)) {
      this.setState({
        titleErrorMsg: "Please enter a valid Job title",
        skillsErrorMsg: "",
      });
    } else if (
      this.state.skills_mustHaveOthers.length === 0 &&
      this.state.skills_mustHave.length === 0
    ) {
      this.setState({
        skillsRequired: true,
        skillsErrorMsg: "Enter at least one skill",
        titleErrorMsg: "",
      });
    } else if (e.target.file.value === "") {
      this.setState({
        fileRequired: true,
        invalidFormat: false,
        skillsRequired: false,
        nameErrorMsg: "",
        skillsErrorMsg: "",
        mobileErrorMsg: "",
        emailErrorMsg: "",
        yearsErrorMsg: "",
        dialCodeMsg: "",
      });
    } else {
      this.setState({
        fileRequired: false,
        invalidFormat: false,
        skillsRequired: false,
      });
      if (
        e.target.min.value === "" ||
        e.target.min.value === undefined ||
        e.target.min.value === null
      ) {
        e.target.min.value = "0";
      }

      const formData = new FormData();
      formData.append("file", e.target.file.files[0]);
      formData.append(
        "jsonData",
        new Blob(
          [
            JSON.stringify({
              allSkills: this.state.commonArray,
              jobTitle: e.target.jobTitle.value,
              maxExperience: `${e.target.max.value}`,
              minExperience: `${e.target.min.value}`,
              mustHaveSkill: this.state.skills_mustHave,
              mustHaveSkillOthers: this.state.skills_mustHaveOthers,
              prefferedSkill: this.state.skills_preferred,
              prefferedSkillOthers: this.state.skills_preferredOthers,
            }),
          ],
          {
            type: "application/json",
          }
        )
      );
      //    console.log('job', {
      //     "allSkills": this.state.commonArray,
      //     "jobTitle": e.target.jobTitle.value,
      //     "maxExperience": `${e.target.max.value}`,
      //     "minExperience": `${e.target.min.value}`,
      //     "mustHaveSkill": this.state.skills_mustHave,
      //     "mustHaveSkillOthers": this.state.skills_mustHaveOthers,
      //     "prefferedSkill": this.state.skills_preferred,
      //     "prefferedSkillOthers": this.state.skills_preferredOthers,
      //    })
      // this.props.onCreateCandidateProfile(formData, 1)
      this.props.createJobProfile(formData, this.props.page);
      this.props.onHide();
      this.unshowResume();
      this.props.sweetAlertModalHandler(true);
    }
    //         else{

    //             const data = {
    //                 "id": "",
    //                 "jobTitle": e.target.jobTitle.value,
    //                 "clientName":e.target.clientname.value,
    //                 "maxExperience": e.target.max.value,
    //                 "minExperience": e.target.min.value,
    //                 "mustHaveSkill": this.state.skills_mustHave,
    //                 "mustHaveSkillOthers": this.state.skills_mustHaveOthers,
    //                 "prefferedSkill": this.state.skills_preferred,
    //                 "prefferedSkillOthers": this.state.skills_preferredOthers,
    //                 "allSkills": this.state.commonArray,
    //         }

    //     this.props.createJobProfile(data,1)
    //     this.props.onHide()
    //     this.props.sweetAlertModalHandler(true)
    // }
  };
  getSkillsList = () => {
    this.props.getSkillsMaster();
  };

  focusInput_job1 = () => {
    document.getElementById("job_input1").focus();
    this.setState({
      skills_mustHave: [],
      skills_preferred: [],
      skills_mustHaveOthers: [],
      skills_preferredOthers: [],
    });
    this.props.sweetAlertModalHandler(false);
  };

  mustHaveSkills = (values) => {
    if (values !== null && values.length === 1) {
      this.setState({
        skillsRequired: false,
        skillsErrorMsg: "",
      });
    }
    let arr_1 = [];
    let arr_2 = [];
    let commonArr = [];
    return values !== null
      ? values.map((value) => {
          if (value.__isNew__) {
            arr_2.push(value.value.trim());
            commonArr.push(value.value.trim());
          } else {
            arr_1.push(value.id);
            commonArr.push(value.id);
          }
          this.setState({
            skills_mustHave: arr_1,
            skills_mustHaveOthers: arr_2,
            commonArray: commonArr,
          });
          return null;
        })
      : this.setState({
          skills_mustHave: [],
          skills_mustHaveOthers: [],
        });
  };

  preferredHaveSkills = (values) => {
    if (values !== null && values.length === 1) {
      this.setState({
        skillsRequired: false,
        skillsErrorMsg: "",
      });
    }
    let arr_1 = [];
    let arr_2 = [];
    let commonArr = [];
    return values !== null
      ? values.map((value) => {
          if (value.__isNew__) {
            arr_2.push(value.value.trim());
            commonArr.push(value.value.trim());
          } else {
            arr_1.push(value.id);
            commonArr.push(value.id);
          }
          this.setState({
            skills_preferred: arr_1,
            skills_preferredOthers: arr_2,
            commonArray: commonArr,
          });
          return null;
        })
      : this.setState({
          skills_preferred: [],
          skills_preferredOthers: [],
        });
  };

  showResume = (event) => {
    event.preventDefault();
    if (event.target.files[0] !== undefined) {
      const myfile = event.target.files[0].name;
      var ext = myfile.split(".").pop();
      var FileSize = event.target.files[0].size / 1024 / 1024;
    }
    if (event.target.files[0] !== undefined) {
      if ((ext == "pdf" || ext == "doc" || ext == "docx") && FileSize <= 3) {
        this.setState({
          file: event.target.files[0].name,
          invalidFormat: false,
          fileRequired: false,
          skillsRequired: false,
        });
      } else {
        document.getElementById("upload").value = null;
        this.setState({
          file: "",
          invalidFormat: true,
          fileRequired: false,
          skillsRequired: false,
        });
      }
    }
  };

  unshowResume = () => {
    this.setState({
      file: "",
      invalidFormat: false,
      fileRequired: false,
      skillsRequired: false,
    });
    document.getElementsByName("file")[0].value = null;
  };

  render() {
    //console.log(this.state.nam)

    let minOptions = [];
    for (let i = 0; i < this.state.max; i++) {
      if (i === 0) {
        minOptions.push({ value: i, label: `${i}` });
      } else if (i === 1) {
        minOptions.push({ value: i, label: `${i} year` });
      } else {
        minOptions.push({ value: i, label: `${i} years` });
      }
    }
    let maxOptions = [];
    for (let i = Number(this.state.min) + 1; i <= 30; i++) {
      if (i === 0) {
        maxOptions.push({ value: i, label: `${i}` });
      } else if (i === 1) {
        maxOptions.push({ value: i, label: `${i} year` });
      } else {
        maxOptions.push({ value: i, label: `${i} years` });
      }
    }

    let monthsOptions = [];
    for (let i = 0; i <= 11; i++) {
      monthsOptions.push({ value: i, label: `${i}` });
    }
    return (
      <Modal
        dialogClassName={classes.createModal}
        {...this.props}
        size="lg"
        backdrop="false"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onShow={() => {
          this.props.sweetAlertModalHandler(false);
          this.focusInput_job1();
        }}
        //  onEntered={() => { this.myfun() }}
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={classes.Title}
        >
          Create My Profile
        </Modal.Title>
        <Modal.Body>
          <Form onSubmit={(e) => this.handleSubmit(e)}>
            <Form.Row className={classes.Row} style={{ marginBottom: "0px" }}>
              <Form.Label
                column
                lg={3}
                md={3}
                sm={4}
                xs={6}
                className={classes.InputFont}
              >
                Title:
              </Form.Label>
              <Col lg={9} md={8} sm={6} xs={10}>
                <Form.Control
                  type="text"
                  className={classes.Input}
                  style={{ width: "98%", marginLeft: "5px" }}
                  name="jobTitle"
                  tabIndex="1"
                  maxLength="37"
                  autoComplete="off"
                  id="job_input1"
                  onFocus={() => {
                    this.setState({ skillsErrorMsg: "", maxErrorMsg: "" });
                  }}
                  onInput={() => this.setState({ titleErrorMsg: "" })}
                />
                <span className={classes.ValidateTitle}>
                  &nbsp;{this.state.titleErrorMsg}
                </span>
              </Col>
            </Form.Row>

            {/* <Form.Row className={classes.Row} style = {{marginBottom: "0px"}}>
                            <Form.Label column lg={3} md={3} sm={4} xs={6} className={classes.InputFont}>
                                Client Name:<br/><span style={{fontSize:"14px"}}>(Optional)</span>
                            </Form.Label>
                            <Col lg={9} md={8} sm={6} xs={10}>
                                <Form.Control type="text" className={classes.Input} style={{ width: '98%', marginLeft: '5px' }}
                                    name="clientname"  tabIndex = "1"                                                                                                                       
                                   maxLength="40"  autoComplete = "off"
                                    id = "clientname"
                                
                                    onFocus = {() => {this.setState({skillsErrorMsg: "", maxErrorMsg: ""})}}
                                    onInput = {() => this.setState({clientErrorMsg: ""})}/>
                                    <span className = {classes.ValidateTitle}>&nbsp;{this.state.clientErrorMsg}</span>
                            </Col>
                        </Form.Row> */}

            <Form.Row className={classes.Row} style={{ marginBottom: "0px" }}>
              <Form.Label
                column
                lg={3}
                md={5}
                className={classes.InputFont}
                style={{ paddingRight: "3px" }}
              >
                Experience:
              </Form.Label>
              <Col lg={3} md={3}>
                {/* <Form.Control as="select" className={classes.Input} name="min" required
                                 onFocus = {() => {this.setState({skillsErrorMsg: "", titleErrorMsg: ""})}}
                                onChange = {(e) => this.setState({min: e.target.value, minValue: this.state.min})}>
                                    {minOptions}
                                </Form.Control> */}
                <Select
                  //  value={{value:1,label:1}}
                  name="min"
                  tabIndex="2"
                  maxMenuHeight="140px"
                  onChange={(text) => {
                    this.setState({ min: text.value });
                  }}
                  onFocus={() => {
                    this.setState({
                      skillsErrorMsg: "",
                      titleErrorMsg: "",
                    });
                  }}
                  options={monthsOptions}
                  styles={{
                    control: (base) => ({
                      ...base,
                      margin: "0",
                      color: "white",
                      border: "1px solid",
                      borderBottom: "1px solid lightgrey",
                      "&:hover": {
                        border: "1px solid !important",
                        borderBottom: "1px solid lightgrey !important",
                        borderRadius: "0",
                      },
                      "&:focus-within": {
                        borderBottom: "1px solid lightgrey !important",
                        boxShadow: "none !important",
                        outline: "none !important",
                        outlineWidth: "0 !important",
                      },
                    }),
                    container: (base) => ({
                      ...base,
                      position: "relative",
                      top: "-6.5px",
                      color: "black",
                      border: "none",
                    }),
                    clearIndicator: (base) => ({
                      ...base,
                      color: "black",
                      border: "none",
                    }),
                    indicatorSeparator: (base) => ({
                      ...base,
                      color: "blue",
                      display: "none",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "-50px",
                      position: "relative",
                      bottom: "-7px",
                      justifyContent: "center",
                    }),
                    placeholder: (base) => ({ ...base, display: "none" }),
                    singleValue: (base, state) => ({
                      ...base,
                      color: "black",
                      fontWeight: "900",
                    }),
                  }}
                />
                <span className={classes.ValidateExp}>
                  &nbsp;{this.state.maxErrorMsg}
                </span>
              </Col>
              <Form.Label
                column
                lg={1}
                md={1}
                className={classes.InputFont}
                style={{ textAlign: "right", marginLeft: "0px" }}
              >
                Years
              </Form.Label>
              <Col lg={3} md={3}>
                <Select
                  name="max"
                  //  value={{value:1,label:1}}
                  tabIndex="3"
                  maxMenuHeight="140px"
                  onChange={(text) => {
                    this.setState({ max: text.value, maxErrorMsg: "" });
                  }}
                  onFocus={() => {
                    this.setState({
                      skillsErrorMsg: "",
                      titleErrorMsg: "",
                    });
                  }}
                  options={monthsOptions}
                  styles={{
                    control: (base) => ({
                      ...base,
                      margin: "0",
                      color: "white",
                      border: "1px solid",
                      borderBottom: "1px solid lightgrey",
                      "&:hover": {
                        border: "1px solid !important",
                        borderBottom: "1px solid lightgrey !important",
                        borderRadius: "0",
                      },
                      "&:focus-within": {
                        borderBottom: "1px solid lightgrey !important",
                        boxShadow: "none !important",
                        outline: "none !important",
                        outlineWidth: "0 !important",
                      },
                    }),
                    container: (base) => ({
                      ...base,
                      position: "relative",
                      top: "-6.5px",
                      color: "black",
                      border: "none",
                    }),
                    clearIndicator: (base) => ({
                      ...base,
                      color: "black",
                      border: "none",
                    }),
                    indicatorSeparator: (base) => ({
                      ...base,
                      color: "blue",
                      display: "none",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "-50px",
                      position: "relative",
                      bottom: "-7px",
                      justifyContent: "center",
                    }),
                    placeholder: (base) => ({ ...base, display: "none" }),
                    singleValue: (base) => ({
                      ...base,
                      color: "black",
                      fontWeight: "900",
                    }),
                  }}
                />
                {/* <Form.Control as="select" className={classes.Input} name="max" required
                                 onFocus = {() => {this.setState({skillsErrorMsg: "", titleErrorMsg: ""})}}
                                onChange = {(e) => this.setState({max: e.target.value })}>
                                     <option hidden></option>
                                    {maxOptions}
                                </Form.Control> */}
              </Col>
              <Form.Label
                column
                lg={1}
                md={1}
                className={classes.InputFont}
                style={{ textAlign: "right" }}
              >
                Months
              </Form.Label>
            </Form.Row>
            <Form.Row className={classes.Row}>
              <Form.Label className={classes.InputFont} column lg={3} md={7}>
                Skills:
              </Form.Label>
              <Col
                lg={9}
                onFocus={() => {
                  this.setState({ titleErrorMsg: "", maxErrorMsg: "" });
                }}
              >
                <MultiSelect
                  tabNo="4"
                  options={this.props.skillList}
                  skills={(values) => this.mustHaveSkills(values)}
                />
                <span className={classes.ValidateSkills}>
                  &nbsp;{this.state.skillsErrorMsg}
                </span>
              </Col>
            </Form.Row>
            {/* <Overlay target={this.target} show={this.state.skillsRequired} placement="right">
                            {props => (
                                <Tooltip id="overlay-example" {...props}>
                                    Enter atleast one skill
                                                        </Tooltip>
                            )}
                        </Overlay> */}
            {/* <Form.Row className={classes.Row} style={{ marginBottom: '40px' }}>
                            <Form.Label className={classes.InputFont} column lg={3} md={7}>
                                <span style={{marginBottom:"-10px"}}>Preferred skills :</span><br /><span style={{position:"relative",top:"-8px", fontSize: '12px',color: "grey",letterSpacing:"1.5px"}}>(Optional)</span>
                            </Form.Label>
                            <Col lg={9}>
                              
                                <MultiSelect 
                                options={this.props.skillList}
                                skills={(values) => this.preferredHaveSkills(values)}
                                 />
                            
                            </Col>
                        </Form.Row> */}

            <Row>
              {this.state.file !== "" ? (
                <div className="col-md-5 sm-md-5 offset-4">
                  <i
                    class="fa fa-window-close"
                    aria-hidden="true"
                    style={{
                      float: "right",
                      margin: "0px 18px -14px 0px",
                      color: "#fbb03b",
                    }}
                    onClick={this.unshowResume}
                  ></i>
                </div>
              ) : null}
              <label
                htmlFor="upload"
                tabIndex="6.5"
                className={` ${classes.IconStyle} ${classes.InputFileText}`}
                style={{
                  marginBottom: "35px",
                  outlineColor: "transparent",
                }}
              >
                {this.state.file !== "" ? (
                  <p style={{ margin: 0 }}>{this.state.file}</p>
                ) : (
                  <i
                    className="fa fa-fw fa-cloud-upload-alt"
                    style={{
                      color: "#fbb03b",
                      marginRight: "22px",
                      fontSize: "23px",
                    }}
                  />
                )}
                <input
                  id="upload"
                  type="file"
                  className={classes.File}
                  accept=".docx,.doc,.pdf"
                  name="file"
                  onInput={() =>
                    this.setState({
                      nameErrorMsg: "",
                      skillsErrorMsg: "",
                      mobileErrorMsg: "",
                      emailErrorMsg: "",
                      yearsErrorMsg: "",
                    })
                  }
                  onChange={(e) => this.showResume(e)}
                  tabIndex="7"
                />
                {this.state.file !== "" ? null : "Upload Resume"}
              </label>
            </Row>
            <Row>
              {this.state.invalidFormat ? (
                <div className={classes.InvalidFormat}>
                  *doc,pdf- Less than 3MB
                </div>
              ) : null}
              {this.state.fileRequired ? (
                <div
                  className={classes.InvalidFormat}
                  style={{ left: "192px" }}
                >
                  Uploading Resume is Mandatory
                </div>
              ) : null}
            </Row>
            <Row className={classes.buttonContainer}>
              <Col lg={6}></Col>
              <Col lg={6}>
                <Button
                  onClick={() => {
                    this.props.onHide();
                    this.unshowResume();
                    this.setState({
                      nameErrorMsg: "",
                      skillsErrorMsg: "",
                      mobileErrorMsg: "",
                      emailErrorMsg: "",
                      yearsErrorMsg: "",
                      maxErrorMsg: "",
                      titleErrorMsg: "",
                      clientErrorMsg: "",
                      fileRequired: "",
                      invalidFormat: "",
                      skillsRequired: "",
                      dialCodeMsg: "",
                    });
                  }}
                  variant="outline-warning"
                  className={classes.Button_1}
                  tabIndex="9"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  tabIndex="8"
                  className={classes.Button_2}
                  variant="warning"
                  tabIndex="8"
                >
                  Create
                </Button>
              </Col>
            </Row>

            {/* <Row style={{marginTop:"58px"}}>
                            <Col lg={6}>
                            </Col>
                            <Col lg={6} style={{marginTop:"-10px", marginBottom: "-10px"}}>
                                <Button onClick={() =>  {this.props.onHide(); 
                                this.setState({min: 0, max: 30,skillsRequired:false, titleErrorMsg: "", skillsErrorMsg: "", maxErrorMsg: ""})}}
                                    variant="outline-warning" className={classes.Button_1} tabIndex = "6">Cancel</Button>
                                <Button type="submit" className={classes.Button_2} variant="warning" tabIndex = "5">Create</Button>
                            </Col>
                        </Row> */}
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    skillLoader: state.employeeReducer.skillLoader,
    skillList: state.employeeReducer.skillList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSkillsMaster: () => dispatch(actionTypes.getSkillsMaster()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateJobProfile);
